<template>
    <div>
        <div class="dialog-footer" style="text-align: right;margin-bottom: 10px">
            <el-button size="small" type="danger" @click="saveData()">
                {{form.id == '' ? '下一步' : '保 存'}}

            </el-button>
        </div>
        <el-form :model="form" :rules="rules" ref="form" label-width="160px">

          <el-form-item label="黑名单名称" prop="blackName">
            <el-input v-model="form.blackName" placeholder="黑名单名称" disabled="disabled"></el-input>
          </el-form-item>

            <el-form-item label="黑名单类型" prop="blackType" >
                <el-select v-model="form.blackType"   placeholder="黑名单类型" disabled="disabled">
                    <el-option
                            v-for="item in blackTypeData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="黑名单手机号" prop="phone">
                <el-input v-model="form.phone" placeholder="黑名单手机号" type="textarea"
                          :autosize="{ minRows: 2, maxRows: 8}"></el-input>多个使用英文逗号","分割
            </el-form-item>
          <el-form-item label="黑名单openId" prop="openId">
            <el-input v-model="form.openId" placeholder="黑名单openId" type="textarea"
                      :autosize="{ minRows: 2, maxRows: 8}"></el-input>多个使用英文逗号","分割
          </el-form-item>
          <el-form-item label="黑名单customerId" prop="customerId" >
            <el-input v-model="form.customerId" placeholder="黑名单customerId" type="textarea"
                      :autosize="{ minRows: 2, maxRows: 8}"></el-input>多个使用英文逗号","分割
          </el-form-item>
          <el-form-item label="黑名单店铺Id" prop="erpShopId">
            <el-input v-model="form.erpShopId" placeholder="黑名单店铺Id" type="textarea"
                      :autosize="{ minRows: 1, maxRows: 5}"></el-input>多个使用英文逗号","分割
          </el-form-item>
          <el-form-item label="黑名单ERP客户Id" prop="erpCustomerId">
            <el-input v-model="form.erpCustomerId" placeholder="黑名单ERP客户Id" type="textarea"
                      :autosize="{ minRows: 1, maxRows: 5}"></el-input>多个使用英文逗号","分割
          </el-form-item>
          <el-form-item label="限量时间单位" prop="unitTimeType">
            <el-select v-model="form.unitTimeType"   placeholder="限量时间单位" >
              <el-option
                  v-for="item in limitTypeData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="每用户限量数" prop="unitTimeLimitCount" >
            <el-input-number v-model="form.unitTimeLimitCount" :min="0" :max="10000"
                             placeholder="每用户限量数" ></el-input-number>零表示不限
          </el-form-item>
          <el-form-item label="每用户同一消息限量数" prop="unitTimeSameLimitCount" >
            <el-input-number v-model="form.unitTimeSameLimitCount" :min="0" :max="10000"
                             placeholder="每用户同一消息限量数" ></el-input-number>零表示不限
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="form.status"   placeholder="状态" >
              <el-option
                  v-for="item in statusData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
    </div>


</template>
<script>
    //导入 HTTP请求方法
    import {
      messageBlackEntity,
      messageBlackSave
    } from '../../api/api';

    import ElDialog from "../../../node_modules/element-ui/packages/dialog/src/component";
    export default {
        components: {ElDialog}, data() {

            return {
                rules: {
                    blackName: [
                        {required: true, message: '请输入黑名单名称', trigger: 'blur'},
                        {min: 1, max: 40, message: '长度在 1 到 40 个字符', trigger: 'blur'}
                    ],
                  // blackType: [
                  //       {type: 'string', required: true, message: '请选择黑名单类型', trigger: 'change'}
                  //   ],
                  // unitTimeType: [
                  //       {type: 'string', required: true, message: '请选择限量时间单位', trigger: 'change'},
                  //   ],
                  unitTimeLimitCount: [
                    {type: 'number', message: '必须为数字'}

                    ],

                  unitTimeSameLimitCount: [
                        {type: 'number', message: '必须为数字'}
                    ],
                  // status: [
                  //   {type: 'string', required: true, message: '请选择状态', trigger: 'change'},
                  // ],
                },
                form: {
                    id:this.$route.query.id,
                    blackName:'',
                    blackType:'',
                    phone:'',
                    customerId:'',
                    openId:'',
                    erpShopId:'',
                    erpCustomerId:'',
                    unitTimeLimitCount:0,
                    unitTimeType:0,
                    status:1,
                    unitTimeSameLimitCount:0,
                },
              statusData:[{id:0,name:"未生效"},{id:1,name:"已生效"}],
              limitTypeData:[{id:1,name:"每小时"},{id:2,name:"每天"},{id:3,name:"每周"}],//1每小时，2每天，3每周
              blackTypeData:[{id:1,name:"短信"},{id:2,name:"公众号模板"},{id:3,name:"公众号订阅消息"},{id:4,name:"公众号客服消息"},{id:5,name:"小程序订阅消息"},{id:6,name:"小程序客服消息"}],

            };

        },
        //props:['activeParam'],
        //挂载时候执行
        mounted(){

          this.getEntity();


        },
        computed: {},
        methods: {
            getEntity(){
                if(this.form.id!=''&&this.form.id!=null) {
                    console.log("id:"+this.form.id);
                    messageBlackEntity({id: this.form.id}).then(res => {
                        this.form = res.data.value;
                    });
                }
            },
            saveData(){
                this.$refs.form.validate((valid)=>{
                   if(valid){
                       this.loading = true;
                     messageBlackSave(this.form).then((res) => {
                           this.loading = false;
                           if (res.data.status == 200) {
                               this.showDialog = false;
                               this.$message({
                                   message: '保存成功',
                                   type: 'success'
                               });

                               if (this.form.id == ''||this.form.id==null) {
                                   this.form = res.data.value;
                                  //editeActive(this.form);
                               }
                             this.$router.push({
                               path: 'messageBlackList',
                               name: 'messageBlackList',
                               query: {

                               }
                             })

                           } else {
                               this.$message({
                                   showClose: true,
                                   message: res.data.message,
                                   type: 'error'
                               });
                           }
                       });
                   }else{
                        //验证不通过
                   }
                });

            },


        }
    }
</script>


// WEBPACK FOOTER //
// src/views/blackList/messageBlackEdit.vue